import { useEffect, useRef, type ReactNode } from 'react';
import Ikon from './Ikon';

/**
 * PENCERE — kısa veri girişi için ortada açılan katman (telefonda alttan çıkar).
 * Esc ve perdeye basmak kapatır (`mesgul` iken kapanmaz), Tab odağı pencerenin içinde tutar,
 * kapanınca odak açan düğmeye döner. Gövde bir <form>'dur: Enter `gonder`i çalıştırır.
 */
export default function Pencere({ baslik, alt, kapat, gonder, eylem, mesgul, children }: {
  baslik: string; alt?: ReactNode; kapat: () => void; gonder: () => void;
  /** Alt satırdaki düğmeler (Vazgeç / Kaydet). */
  eylem: ReactNode; mesgul?: boolean; children: ReactNode;
}) {
  const kutu = useRef<HTMLFormElement>(null);
  useEffect(() => {
    const onceki = document.activeElement as HTMLElement | null;
    const tus = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.stopPropagation(); if (!mesgul) kapat(); return; }
      if (e.key !== 'Tab' || !kutu.current) return;
      const odak = [...kutu.current.querySelectorAll<HTMLElement>('input, button, select, textarea, a[href]')].filter((x) => !x.hasAttribute('disabled'));
      if (odak.length === 0) return;
      const ilk = odak[0], son = odak[odak.length - 1];
      if (e.shiftKey && document.activeElement === ilk) { e.preventDefault(); son.focus(); }
      else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
    };
    document.addEventListener('keydown', tus, true);
    return () => { document.removeEventListener('keydown', tus, true); onceki?.focus?.(); };
  }, [kapat, mesgul]);
  return (
    <div className="ccd-pencere-perde" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget && !mesgul) kapat(); }}>
      <form ref={kutu} className="ccd-pencere" role="dialog" aria-modal="true" aria-label={baslik} noValidate
            onSubmit={(e) => { e.preventDefault(); gonder(); }}>
        <div className="ccd-pencere-ust">
          <div style={{ minWidth: 0 }}>
            <h2 className="ccd-pencere-baslik">{baslik}</h2>
            {alt && <div className="ccd-meta">{alt}</div>}
          </div>
          <button type="button" className="ccd-ust-btn" onClick={kapat} disabled={mesgul} aria-label="Kapat"><Ikon ad="kapat" boy={18} /></button>
        </div>
        <div className="ccd-pencere-govde">{children}</div>
        <div className="ccd-pencere-eylem">{eylem}</div>
      </form>
    </div>
  );
}
